/* src/app/ai-sourcing/ai-sourcing-profile-slider/ai-sourcing-profile-slider.component.scss */
.btn-trms-regular {
  color: rgba(205, 15, 15, 0.5411764706) !important;
  border-color: rgba(205, 15, 15, 0.5411764706) !important;
}
.btn-trms-small {
  width: 50%;
  background-color: #ffffff;
  color: #2e93a1;
}
/*# sourceMappingURL=ai-sourcing-profile-slider.component-OFPDCFZA.css.map */
